import React from 'react';
import panda from "../components/images/panda.png";


const HomePage = ({ isAuthenticated, activeEventId, availableEvents, onEventSwitch }) => {
  const activeEventName = availableEvents?.find(ev => ev.event_id === activeEventId)?.event_name;

  return (
    <div className="home-page">
      <img style={{ width: "20%", height: "20%" }} src={panda} alt="Panda Notify logo"/>
      <h2 className="home-title">
        {isAuthenticated ? 'Panda Notify - Logged In' : 'Panda Notify'}
      </h2>
      <p className="home-description">
        {isAuthenticated
          ? 'Select an option from the menu at the top.'
          : "Your event's next messaging and notification solution!"}
      </p>
      {isAuthenticated && activeEventName && (
        <div className="home-event-info">
          <p className="home-event-text">
            The event you are currently updating is <strong>{activeEventName}</strong>
          </p>
          {availableEvents && availableEvents.length > 1 && (
            <select
              className="profile-event-select"
              value={activeEventId || ''}
              onChange={(e) => onEventSwitch(e.target.value)}
            >
              {availableEvents.map(ev => (
                <option key={ev.event_id} value={ev.event_id}>
                  {ev.event_name}
                </option>
              ))}
            </select>
          )}
        </div>
      )}
    </div>
  );
};

export default HomePage;